export default __webpack_public_path__ + "static/media/no_avatar.65822282.svg";